import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="logo">
              Midnight <span>Aurelia</span>
            </Link>
            <p>
              Creating Pinterest-worthy celebrations with expert styling 
              consultations and ready-to-style party boxes. Let's make your 
              next gathering unforgettable.
            </p>
            <div className="footer-social">
              <a href="https://instagram.com/midnightaureliaevents" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                📸
              </a>
              <a href="https://pinterest.com/midnightaureliaevents" target="_blank" rel="noopener noreferrer" aria-label="Pinterest">
                📌
              </a>
              <a href="https://tiktok.com/@midnightaureliaevents" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                🎵
              </a>
            </div>
          </div>

          <div className="footer-column">
            <h4>Services</h4>
            <ul>
              <li><Link to="/services">The Glow Guide</Link></li>
              <li><Link to="/services">The Golden Touch</Link></li>
              <li><Link to="/services">The Radiant Host</Link></li>
              <li><Link to="/services">The Full Affair</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Party Boxes</h4>
            <ul>
              <li><Link to="/party-boxes">Baby Shower</Link></li>
              <li><Link to="/party-boxes">Birthday</Link></li>
              <li><Link to="/party-boxes">Bachelorette</Link></li>
              <li><Link to="/party-boxes">Dinner Party</Link></li>
              <li><Link to="/party-boxes">View All Boxes</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/contact">Book a Consult</Link></li>
              <li><a href="https://instagram.com/midnightaureliaevents" target="_blank" rel="noopener noreferrer">Follow Us</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Midnight Aurelia Events. All rights reserved.</p>
          <a
            href="https://softangeles.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', marginTop: '14px', opacity: 0.9, fontSize: '15px', fontWeight: 500, textDecoration: 'none', color: '#ffffff' }}
          >
            <span>Powered by</span>
            <img src="https://softangeles.com/logo-wide.png" alt="SoftAngeles" style={{ height: '30px', width: 'auto' }} />
          </a>
          <div className="footer-bottom-links">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
